/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.moderation.listScheduledActions'

export { $nsid }

/** List scheduled moderation actions with optional filtering */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    startsAfter: l.optional(l.string({ format: 'datetime' })),
    endsBefore: l.optional(l.string({ format: 'datetime' })),
    subjects: l.optional(
      l.array(l.string({ format: 'did' }), { maxLength: 100 }),
    ),
    statuses: l.array(
      l.string<{
        knownValues: ['pending', 'executed', 'cancelled', 'failed']
      }>(),
      { minLength: 1 },
    ),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    actions: l.array(
      l.ref<ModerationDefs.ScheduledActionView>(
        (() => ModerationDefs.scheduledActionView) as any,
      ),
    ),
    cursor: l.optional(l.string()),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
